import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import DormitoryForm from "Components/Form/DormitoryForm";
import {
  useGetDormitoryByIdQuery,
  useUpdateDormitoryMutation,
} from "AppQuries/master/dormitory";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
import { dormitoryValidationSchema } from "core/Operations/ValidationSchema/MasterValidationSchema";
const EditDormitory = () => {
  const userData = useSelector(loggedInUser);
  const { code } = useParams();
  const {
    data: dormitoryData,
    isLoading,
    isError: isFetchingError,
    error: fetchingError,
  } = useGetDormitoryByIdQuery(
    {
      companyCode: userData?.companyCode,
      code: code,
    },
    {
      enabled: !!code,
    }
  );

  const {
    mutate: updateDormitory,
    isPending,
    isError,
    error,
  } = useUpdateDormitoryMutation();
  const methods = useForm({
    defaultValues: {
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    },
    resolver: yupResolver(dormitoryValidationSchema),
  });

  const { setValue } = methods;

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmit = (payload) => {
    console.log(payload);
    updateDormitory(payload, {
      onSuccess: (data) => {
        console.log(data);
        if (data === true) {
          toast.success("Dormitory Updated Successfully.");
          
          setTimeout(() => {
            navigate(`${all_routes.master}${all_routes.dormitory}`);
          }, 1000);
        } else {
          toast.warning("Something went wrong.");
        }
      },
      onError: (error) => {
        toast.toast(error.message || "Something went wrong.");
      },
    });
  };

  console.log(errors);

  useEffect(() => {
    if (Array.isArray(dormitoryData) && dormitoryData.length > 0) {
      Object.keys(dormitoryData[0]).forEach((key) => {
        setValue(key, dormitoryData[0][key]);
      });
    }
  }, [dormitoryData]);
  if (isError) return <Error404 error={error} />;
  if (isFetchingError) return <Error404 error={fetchingError} />;
  if (isLoading || isPending) return <LoadingSpinner />;
  return (
    <div>
    
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Edit Dormitory</h4>
                    <h6>Edit your domitory details </h6>
                  </div>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">Update Dormitory</Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Update
                    </button>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                  >
                    <Link
                      to={`${all_routes.master}${all_routes.dormitory}`}
                      className="btn btn-secondary"
                    >
             <BackIcon className="me-2" />
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Edit Dormitory</h4>
                    </div>
                    <div className="card-body">
                      <DormitoryForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default EditDormitory;
